// export const config = {
//   Api: 'http://127.0.0.1:8001/api/',                                           //Local server
//   // Api: 'https://goldsun-node.vercel.app/api/',
//   // Api:'https://goldsun-node.onrender.com/api/'
//   // Api:'https://goldsun-node.eniscloud.in/api/'
// };

export const config = {
  Api: '/api/' 
};